<template>
  <section class="checkout-payment-embed checkout-payment-embed--stripe">
    <span class="checkout-payment-embed__label">Stripe</span>
    <p class="checkout-payment-embed__copy">Paga sin salir de FOMO. Si tu banco pide validación extra, Stripe la abre aquí mismo.</p>

    <div v-if="errorMessage" class="workspace-feedback workspace-feedback--error">{{ errorMessage }}</div>
    <div v-if="successMessage" class="workspace-feedback workspace-feedback--success">{{ successMessage }}</div>

    <div v-show="loading" class="checkout-payment-embed__loading">Preparando pago seguro...</div>
    <div ref="paymentElement" class="checkout-payment-embed__mount"></div>

    <div class="workspace-actions workspace-actions--end">
      <button class="workspace-button workspace-button--primary" type="button" :disabled="loading || confirming || !ready" @click="confirmPayment">
        {{ confirming ? 'Confirmando...' : `Pagar ${formattedAmount}` }}
      </button>
    </div>
  </section>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'
import { formatCurrencyAmount, normalizeCurrencyCode } from '../../common/currency.js'

export default {
  name: 'StripePaymentElement',
  props: {
    attemptToken: {
      type: String,
      required: true,
    },
    clientSecret: {
      type: String,
      required: true,
    },
    publishableKey: {
      type: String,
      required: true,
    },
    amount: {
      type: [Number, String],
      default: 0,
    },
    currency: {
      type: String,
      default: 'USD',
    },
  },
  data() {
    return {
      loading: false,
      confirming: false,
      ready: false,
      stripe: null,
      elements: null,
      paymentElement: null,
      errorMessage: '',
      successMessage: '',
    }
  },
  computed: {
    formattedAmount() {
      return formatCurrencyAmount(this.amount, normalizeCurrencyCode(this.currency, 'USD'))
    },
  },
  mounted() {
    this.initialize()
  },
  methods: {
    async initialize() {
      this.loading = true
      this.errorMessage = ''
      if (!this.publishableKey || !this.clientSecret) {
        this.loading = false
        this.errorMessage = 'Faltan credenciales publicas de Stripe o client secret.'
        return
      }

      this.stripe = await loadStripe(this.publishableKey)
      if (!this.stripe) {
        this.loading = false
        this.errorMessage = 'Stripe no pudo cargarse en este navegador.'
        return
      }

      this.elements = this.stripe.elements({ clientSecret: this.clientSecret, appearance: { theme: 'stripe' } })
      this.paymentElement = this.elements.create('payment')
      this.paymentElement.mount(this.$refs.paymentElement)
      this.ready = true
      this.loading = false
    },
    async confirmPayment() {
      if (!this.stripe || !this.elements) {
        return
      }
      this.confirming = true
      this.errorMessage = ''
      const { error, paymentIntent } = await this.stripe.confirmPayment({
        elements: this.elements,
        redirect: 'if_required',
      })

      this.confirming = false
      if (error) {
        this.errorMessage = error.message || 'Stripe no pudo confirmar el pago.'
        return
      }

      this.successMessage = 'Pago confirmado. Estamos validando tu compra.'
      this.$emit('completed', {
        attemptToken: this.attemptToken,
        paymentIntentId: paymentIntent && paymentIntent.id ? paymentIntent.id : '',
        status: paymentIntent && paymentIntent.status ? paymentIntent.status : 'processing',
      })
    },
  },
}
</script>

<style scoped>
.checkout-payment-embed--stripe {
  display: grid;
  gap: 16px;
  padding: 18px;
  border-radius: 20px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: rgba(255, 255, 255, 0.94);
}

.checkout-payment-embed__copy,
.checkout-payment-embed__loading {
  color: #475569;
  margin: 0;
}

.checkout-payment-embed__mount {
  min-height: 48px;
}
</style>
